import get from 'lodash/get';
import omit from 'lodash/omit';
import { Form } from 'react-bootstrap';
import { FieldErrors, FieldValues, UseFormRegister } from 'react-hook-form';
import { ApiError } from '../../../api';
import { ShowFieldErrors } from '../../../utils/forms';
import { FormFeedback } from '../FormFeedback';
import { FormFieldVisibility, FormLabel } from '../FormLabel';

interface FormTextFieldProps {
  name: string;
  label: string;
  serverErrors?: ApiError;
  showServerFieldErrors?: ShowFieldErrors;
  setShowServerFieldErrors?: (showServerFieldErrors: ShowFieldErrors) => void;
  errors: FieldErrors<FieldValues>;
  register: UseFormRegister<FieldValues>;
  extraFieldErrorsToHideOnChange?: string[];
  required?: boolean;
  srOnlyLabel?: boolean;
  visibility?: FormFieldVisibility;
  className?: string;
  inputInfo?: string;
  labelClassNames?: string;
  placeholder?: string;
}

export const FormTextField = ({
  name,
  label,
  serverErrors,
  showServerFieldErrors,
  setShowServerFieldErrors,
  errors,
  register,
  extraFieldErrorsToHideOnChange = [],
  required = false,
  srOnlyLabel = false,
  className = 'mb-2',
  labelClassNames,
  visibility,
  inputInfo,
  placeholder = '',
  ...rest
}: FormTextFieldProps & Parameters<typeof Form.Control>[0]) => (
  <Form.Group className={className} controlId={name}>
    {label && (
      <FormLabel
        required={required}
        classNames={labelClassNames}
        visibility={visibility}
        srOnlyLabel={srOnlyLabel}
      >
        {label}
      </FormLabel>
    )}
    <div className={'position-relative'}>
      <Form.Control
        type="text"
        required={required}
        placeholder={placeholder}
        {...register(name, {
          onChange: () =>
            setShowServerFieldErrors?.({
              ...omit(showServerFieldErrors, [name, ...extraFieldErrorsToHideOnChange]),
            }),
        })}
        {...rest}
        isInvalid={!!get(showServerFieldErrors, name) || !!get(errors, name)}
      />
      {inputInfo && <span className="input-info">{inputInfo}</span>}
    </div>
    <FormFeedback
      clientError={get(errors, name)}
      serverErrors={get(showServerFieldErrors, name) ? get(serverErrors?.body, name) : null}
    />
  </Form.Group>
);
